import { BARCODE_BORDER_COLOR_HEX, TICKET_BG_COLOR_HEX } from '../../wallet/wallet.constants';
import { TicketModel } from '@/v2/models/ticketModel';

export function getHeaderBackgroundColor(ticket: TicketModel) : string | null{
  if (ticket.voidedAt != null) {
    return null;
  }
  return ticket.bgColorHex;
}

export function getTicketBackgroundColor(ticket: TicketModel) : string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  return TICKET_BG_COLOR_HEX;
}

export function getBarcodeBorderColor(ticket: TicketModel) : string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  return BARCODE_BORDER_COLOR_HEX;
}

export function getTextFontColor(ticket: TicketModel) : string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  return ticket.fontColorHex;
}
